// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1c3lF","productName":"Table_productName__1RPDK"};